const NgarkoOlimp = () => {
  return <div><h2>Upload Olymp Files</h2></div>;
};

export default NgarkoOlimp;
